import { yupResolver } from '@hookform/resolvers/yup'
import { useForm } from 'react-hook-form'
import * as yup from 'yup'

export type ZoomDocNYRegisterFormData = yup.InferType<typeof formSchema>

const formSchema = yup.object({
    email: yup.string().email().required(),
    name: yup.string().required(),
    establishment: yup.string().optional(),
    phone: yup.string(),
    secu: yup
        .string()
        .matches(/^\d+$/)
        .max(15)
        .min(15)
        .nullable()
        .transform((value) => value || undefined),
    surname: yup.string().required(),
    birthday: yup.date().required('Birthday is required'),
    gender: yup.string().oneOf(['M', 'F', 'I', 'O'], 'Invalid gender').required('Gender is required'),
    terms: yup.boolean().oneOf([true]).required(),
    password: yup.string().required('Password is required').min(8, 'Password must be at least 8 characters'),
    confirmPassword: yup
        .string()
        .oneOf([yup.ref('password')], 'Passwords must match')
        .required('Confirm password is required'),
    // US Insurance fields
    insured: yup.string().optional(),
    insuredRelationship: yup.string().optional(),
    insuranceProvider: yup.string().optional(),
    primaryInsurance: yup.string().optional(),
    secondaryInsurance: yup.string().optional(),
    primaryPolicy: yup.string().optional(),
    secondaryPolicy: yup.string().optional(),
    primaryPharmacy: yup.string().optional(),
})

export function useZoomDocNYRegisterForm() {
    return useForm<ZoomDocNYRegisterFormData>({
        defaultValues: {
            email: '',
            name: '',
            establishment: '',
            phone: '',
            secu: '',
            surname: '',
            birthday: undefined,
            gender: undefined,
            terms: false,
            password: '',
            confirmPassword: '',
            insured: '',
            insuredRelationship: '',
            insuranceProvider: '',
            primaryInsurance: '',
            secondaryInsurance: '',
            primaryPolicy: '',
            secondaryPolicy: '',
            primaryPharmacy: '',
        },
        mode: 'onChange',
        resolver: yupResolver(formSchema),
    })
}
